var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"step-skip"},[_c('div',[_vm._v(" If you do not have your "+_vm._s(_vm.verificationStep)+" with you, you can upload it later and "),_c('button',{staticClass:"step-skip__link",class:_vm.textColorClass(),on:{"click":function($event){return _vm.$emit('skip')}}},[_vm._v(" skip for now ")]),_vm._v(". ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }